import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import mainBanner from '@/assets/img/banner/society.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import CompleteModal from '@/components/common/Modal/CompleteModal/CompleteModal';
import ModalBox from '@/components/common/Modal/ModalBox/ModalBox';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import TabList from '@/components/common/Tab/TabList/TabList';
import AbstractConfirm from '@/components/Society/AbstractConfirm/AbstractConfirm';
import AbstractGuide from '@/components/Society/AbstractGuide/AbstractGuide';
import SocietyConfirm from '@/components/Society/SocietyConfirm/SocietyConfirm';
import SocietyGuide from '@/components/Society/SocietyGuide/SocietyGuide';
import SocietyRegister from '@/components/Society/SocietyRegister/SocietyRegister';
import { useModalStore } from '@/store/modalStore';

const menuList = ['학술행사 안내', '초록 안내 및 등록', '학술대회 등록'];

const Society = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const { showModal } = useModalStore();
	const [searchParams] = useSearchParams();
	const [isOpen, setIsOpen] = useState(false);
	const params = location.state?.menu ?? '학술행사 안내';
	const stepParams = location.state?.step;
	const successParams = searchParams.get('sucess') ?? '';
	const failParams = searchParams.get('aid') ?? '';

	const handleSetMenu = (menu: string) => {
		navigate('/society', { state: { menu: menu } });
	};

	useEffect(() => {
		if (successParams === 'true') {
			setIsOpen(true);
		}
		if (successParams === 'false' || failParams !== '') {
			showModal('결제에 실패했습니다. \n다시 시도해 주세요.');
			navigate('/society', { state: { menu: '연회비 납부' } });
			return;
		}
	}, [params, successParams, failParams]);

	return (
		<main>
			<SubBanner subTitle="Society activities" title="학술행사 일정 안내" img={mainBanner} />

			<TabList menuList={menuList} menuKey={params} onListClick={handleSetMenu} />
			{params === menuList[0] && <SocietyGuide />}
			{params === menuList[1] && stepParams !== '초록 확인' && <AbstractGuide />}
			{params === menuList[1] && stepParams === '초록 확인' && <AbstractConfirm />}
			{params === menuList[2] && stepParams !== '등록 확인' && <SocietyRegister />}
			{params === menuList[2] && stepParams === '등록 확인' && <SocietyConfirm />}

			{isOpen && (
				<ModalPortal>
					<ModalBox onClick={() => setIsOpen(false)}>
						<CompleteModal closeModal={setIsOpen} />
					</ModalBox>
				</ModalPortal>
			)}
		</main>
	);
};

export default Society;
